<div class="loan-section">
  <div class="input-group">
    <app-loan-input label="Full Name" [control]="$any(applicantFormGroup).get('fullName')" />
  </div>

  <div class="input-group">
    <app-loan-input label="Email" [control]="$any(applicantFormGroup).get('email')" [readonly]="readonlyEmail" [tooltipText]="emailTooltipText" />
    <app-loan-input label="Phone" [control]="$any(applicantFormGroup).get('phone')" />
  </div>
</div>
